import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import Input from '@vtex/styleguide/lib/Input'
import Button from '@vtex/styleguide/lib/Button'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import * as WebViewBridge from '@/checkout-instore-legacy/utils/WebViewBridge'
import BarcodeReader from '@/checkout-instore-legacy/utils/BarcodeReader'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import ModalSubtitle from '@/checkout-instore-legacy/components/Commons/ModalTitle/ModalSubtitle'
import ModalScanAlert from '@/checkout-instore-legacy/components/Commons/Scan/ModalScanAlert'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

class Coupon extends Component {
  constructor(props) {
    super(props)
    this.state = {
      couponCode: this.props.value,
      showScanScreen: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.props.onClose()
    }
    if (nextProps.value !== this.props.value || !nextProps.isOpen) {
      this.setState({ couponCode: nextProps.value, showScanScreen: false })
    }
  }

  handleChange = (e, callback) => {
    this.setState(
      { couponCode: e.target.value, showScanScreen: false },
      callback
    )
  }

  handleFormSubmit = (e) => {
    e && e.preventDefault()
    if (!this.state.couponCode) {
      return
    }
    logClickEvent('submit-coupon-button', 'Sale')
    this.props.addCoupon(this.state.couponCode)
  }

  handleRemove = () => {
    this.props.removeCoupon()
  }

  componentDidMount() {
    BarcodeReader.listen(this.handleBarcodeRead)
    window.handleBarcodeRead = (barcode) =>
      this.handleBarcodeRead({ data: { barcode } }) // used on custom scripts
  }

  componentWillUnmount() {
    BarcodeReader.unlisten(this.handleBarcodeRead)
    window.handleBarcodeRead = null
  }

  handleBarcodeRead = (event) => {
    let { barcode } = event.data

    if (barcode) {
      barcode = barcode.toString()
    }

    this.handleChange({ target: { value: barcode } }, () => {
      this.handleFormSubmit()
    })
  }

  handleToggleScanScreen = () => {
    const newShowScanScreen = !this.state.showScanScreen

    if (newShowScanScreen) {
      this.handleOpenCamera()
    }

    this.setState({
      showScanScreen: newShowScanScreen,
    })
  }

  handleOpenCamera() {
    WebViewBridge.sendEvent({
      type: 'openBarcodeCameraVisible',
    })
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.value !== this.props.value || !nextProps.isOpen) {
      return false
    }
    return true
  }

  render() {
    const { couponCode, showScanScreen } = this.state
    const { intl, mediaQuery, isLoading } = this.props
    const savedValue = this.props.value
    const trimmedCode = couponCode.trim()
    const showSideButton = mediaQuery({
      phone: false,
      tablet: false,
      desktop: true,
    })

    return (
      <div>
        <ModalTitle id="cartCouponTitle" />
        {!savedValue && <ModalSubtitle id="cartCouponSubtitle" />}
        {savedValue ? (
          <div>
            <div className="flex flex-auto tl mt7">
              <Input
                id="couponCode"
                type="text"
                label={intl.formatMessage({
                  id: 'couponCodeLabel',
                })}
                className="f4 f3-ns"
                value={savedValue}
                disabled
              />
            </div>
            <div className="flex justify-end mt5 mt7-l">
              <Button
                id="couponRemove"
                variation="danger"
                onClick={this.handleRemove}
                isLoading={isLoading}
                block={!showSideButton}
              >
                <FormattedMessage id="couponRemoveLabel" />
              </Button>
            </div>
          </div>
        ) : showScanScreen ? (
          <ModalScanAlert onCancel={this.handleToggleScanScreen} />
        ) : (
          <form onSubmit={this.handleFormSubmit}>
            <div className="flex flex-auto items-end tl">
              <div className="flex flex-auto">
                <Input
                  id="couponCode"
                  type="text"
                  label={intl.formatMessage({
                    id: 'couponCodeLabel',
                  })}
                  className="f4 f3-ns"
                  value={couponCode}
                  onChange={this.handleChange}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              </div>
              {showSideButton && (
                <div className="ml4">
                  <Button
                    id="couponSubmit"
                    variation="primary"
                    type="submit"
                    disabled={!trimmedCode}
                    isLoading={isLoading}
                  >
                    <FormattedMessage id="addPaymentFormAdd" />
                  </Button>
                </div>
              )}
            </div>
            {!showSideButton && (
              <div className="flex justify-end mt5 mt7-l">
                <Button
                  id="couponSubmit"
                  type="submit"
                  variation="primary"
                  disabled={!trimmedCode}
                  isLoading={isLoading}
                  block
                >
                  <FormattedMessage id="couponAddLabel" />
                </Button>
              </div>
            )}
            <div className="tc ma6">
              <FormattedMessage id="orLabel" />
            </div>
            <div className="flex justify-center mt5">
              <Button
                id="couponScan"
                type="button"
                variation="secondary"
                onClick={this.handleToggleScanScreen}
                block={!showSideButton}
              >
                <FormattedMessage id="scanCode" />
              </Button>
            </div>
          </form>
        )}
      </div>
    )
  }
}

Coupon.propTypes = {
  value: PropTypes.any,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  intl: intlShape.isRequired,
  mediaQuery: PropTypes.func.isRequired,
  addCoupon: PropTypes.func.isRequired,
  removeCoupon: PropTypes.func.isRequired,
}

export default injectIntl(withMediaQuery(Coupon))
